import React from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { TagType } from '@rome/response/common/TagType';
import { BrowsePages } from 'constants/pageTypes';
import { stringTemplate } from 'components/StringWidget/StringWidget';
import styles from './Tags.css';
export function Tags(props) {
    const { tags, containerClass, pageType } = props;
    if (!tags || !Array.isArray(tags) || (Array.isArray(tags) && tags.length === 0)) {
        return null;
    }
    return (<div className={cx(styles['tags'], containerClass)}>
			{tags.map(priceTag => {
        if (priceTag.tagType === TagType.PRE_BOOK) {
            const text = priceTag.text || stringTemplate('preOrderTagText');
            /*
                There is requirement from the Search product team to show the "Pre Book" tag
                simply as text if it's being shown on a Browse-like page. This has to be solved
                by powering different data from mAPI based on the page. Adding this hack after
                for the time being. Once the solution is done from the server end this will be
                removed.
            */
            const showOnlyText = pageType && BrowsePages.indexOf(pageType) > -1;
            return (<div key={priceTag.tagType} className={showOnlyText ? styles['pre-order-text-only'] : styles['pre-order']}>
							{text}
						</div>);
        }
        return null;
    })}
		</div>);
}
const mapStateToProps = (state) => ({
    pageType: get(state, 'pageDataV4.page.pageType')
});
export default connect(mapStateToProps)(Tags);
